<template>
  <v-card outlined rounded class="px-3 py-4">
    <div class="text-overline--small neutral--text text--darken-1">
      {{ $t('fields.account.billing.payment.payment_methods_section') }}
    </div>

    <Alert v-if="hasError" type="error" icon="forbidden-system" inline regular-title small class="mt-3">
      <template #title>
        <span class="font-weight-semi-bold">
          {{ $t('fields.account.billing.payment.payment_method_error') }}
        </span>
        <v-btn text :ripple="false" color="primary" x-small class="ml-1" @click="onRetry">
          <span class="navy--text">
            {{ $t('fields.account.billing.payment.try_again') }}
          </span>
        </v-btn>
      </template>
    </Alert>
  </v-card>
</template>

<script lang="ts">
import Alert from '@/components/Alert.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Alert,
  },
})
export default class PaymentMethodListError extends Vue {
  @Prop({ required: true })
  hasError!: boolean;

  @Emit('retry')
  onRetry(): void {
    // Reloads payment methods in the parent list.
  }
}
</script>
